import { Product } from '../types';

export const availableProducts: Product[] = [
  { name: 'Fresh Milk', category: 'Dairy', defaultExpiry: 5, defaultUnit: 'L' },
  { name: 'Greek Yogurt', category: 'Dairy', defaultExpiry: 7, defaultUnit: 'g' },
  { name: 'Chicken Breast', category: 'Meat', defaultExpiry: 3, defaultUnit: 'kg' },
  { name: 'Ground Beef', category: 'Meat', defaultExpiry: 2, defaultUnit: 'kg' },
  { name: 'Salmon Fillet', category: 'Meat', defaultExpiry: 2, defaultUnit: 'kg' },
  { name: 'Broccoli', category: 'Vegetables', defaultExpiry: 5, defaultUnit: 'pcs' },
  { name: 'Carrots', category: 'Vegetables', defaultExpiry: 10, defaultUnit: 'kg' },
  { name: 'Spinach', category: 'Vegetables', defaultExpiry: 4, defaultUnit: 'g' },
  { name: 'Strawberries', category: 'Fruits', defaultExpiry: 3, defaultUnit: 'g' },
  { name: 'Bananas', category: 'Fruits', defaultExpiry: 4, defaultUnit: 'pcs' },
  { name: 'Apples', category: 'Fruits', defaultExpiry: 14, defaultUnit: 'pcs' },
  { name: 'Cheese Block', category: 'Dairy', defaultExpiry: 20, defaultUnit: 'g' },
  { name: 'Orange Juice', category: 'Beverages', defaultExpiry: 5, defaultUnit: 'L' },
  { name: 'Eggs', category: 'Dairy', defaultExpiry: 21, defaultUnit: 'pcs' },
  { name: 'Butter', category: 'Dairy', defaultExpiry: 30, defaultUnit: 'g' },
  { name: 'Tomatoes', category: 'Vegetables', defaultExpiry: 7, defaultUnit: 'kg' },
];